import React from "react";

import { Grid, Typography } from "@material-ui/core";
import { Investment } from "common/store/investment/types";
import { StoreState } from "common/store/types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import "./ShareInfo.scss";

export const ShareInfo = () => {
  //Hooks
  const { t } = useTranslation();
  const currentShare = useSelector<StoreState, Investment>(
    (state) => state.currentShare
  );

  return (
    <div className="share-info">
      <Grid item lg={12} md={12} xs={12}>
        <Typography className="title" variant="subtitle1">
          {t("Property #")}
          {currentShare.sale_id}
        </Typography>
      </Grid>
      <Grid item container spacing={4}>
        <Grid item lg={4} md={4} xs={4}>
          <div className="item-label">{t("Total shares")}</div>
          <div className="item-value">{currentShare.amount}</div>
        </Grid>
        <Grid item lg={4} md={4} xs={4}>
          <div className="item-label">{t("Total amount")}</div>
          <div className="item-value">€ {currentShare.toBePaid}</div>
        </Grid>
      </Grid>
    </div>
  );
};
